var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBezierCurve = function SvgIconBezierCurve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.907 6.5H1.5a1 1 0 0 0 0 2h4.755a9.26 9.26 0 0 0-3.186 4.822 3.251 3.251 0 0 0 .681 6.428 3.25 3.25 0 0 0 1.34-6.212 7.26 7.26 0 0 1 4.07-4.457 3.25 3.25 0 0 0 5.68 0 7.26 7.26 0 0 1 4.07 4.457 3.25 3.25 0 1 0 2.021-.216A9.26 9.26 0 0 0 17.744 8.5H22.5a1 1 0 1 0 0-2h-7.407a3.252 3.252 0 0 0-6.186 0m1.843 1a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-7 7.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M19 16.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconBezierCurve;